import { translate } from '@vimeo/i18n-runtime';

export const RADIO_UNSELECTED = 'unselected';

const ReportTypes = {
  PORN: 'pornographic',
  HARASSMENT: 'harassment',
  RIPOFF: 'ripoff',
  INCORRECT_RATING: 'incorrect rating',
  SPAM: 'spam',
  CAUSES_HARM: 'causes harm',
  CSAM: 'csam',
  VOTING_MISINFORMATION: 'voting misinformation',
};

export const ReportReasons: { title: string; description: string; value: string }[] = [
  {
    title: translate('XXX-rated'),
    description: translate(
      'This video contains pornography, advertises a product or service of an erotic nature, or seems primarily focused on sexual stimulation.',
    ),
    value: ReportTypes.PORN,
  },
  {
    title: translate('Not playing nice'),
    description: translate(
      'This video contains harassment, incites hatred, or depicts extreme or real-life violence.',
    ),
    value: ReportTypes.HARASSMENT,
  },
  {
    title: translate('Uploader did not make this'),
    description: translate(
      "The person who uploaded this video obviously didn't make it (it's a TV show, movie trailer, or ripped from elsewhere on the web).",
    ),
    value: ReportTypes.RIPOFF,
  },
  {
    title: translate('Incorrect rating'),
    description: translate(
      'This video should be marked as "Mature" due to nudity, profanity, violence, or drug/alcohol use.',
    ),
    value: ReportTypes.INCORRECT_RATING,
  },
  {
    title: translate('Spam'),
    description: translate(
      'This video is primarily designed to drive traffic to third party sites, use Search Engine Optimization (SEO) to manipulate search rankings, or otherwise deceive or mislead the audience.',
    ),
    value: ReportTypes.SPAM,
  },
  {
    title: translate('Strong potential to cause harm'),
    description: translate(
      'This video depicts or encourages self-harm, falsely claims that mass tragedies are hoaxes, or perpetuates false or misleading claims about vaccine safety.',
    ),
    value: ReportTypes.CAUSES_HARM,
  },
  {
    title: translate('Displays harm to minors'),
    description: translate('This video depicts harm or exploitation of a minor.'),
    value: ReportTypes.CSAM,
  },
  {
    title: translate('Misleads viewers about voting, elections, or election results'),
    description: translate(
      'This video contains false or misleading information about voting, candidate eligibility, or election results, or otherwise seeks to obstruct the voting or election process.',
    ),
    value: ReportTypes.VOTING_MISINFORMATION,
  },
];
